<template>
    <div class="training-step5">
        <div class="training-step5-flex">
            <div class="training-step5-flex-item flex-item-bg1">
                <div class="item-title">
                    <div class="item-title__text">结业情况</div>
                </div>
                <div class="item-percent"><span class="item-percent__num">{{rules.graduationReportObj.finish.percent}}</span><span class="item-percent__symbol">%</span></div>
                <div class="item-tip">结业率</div>
                <div class="item-percent-flex item-percent-flex2">
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.graduationReportObj.finish.percent" :stroke-width="15" color="#4A76F5" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.graduationReportObj.finish.num}}</div>
                            <div class="item-percent-text__desc">已结业</div>
                        </div>
                    </div>
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.graduationReportObj.keep.percent" :stroke-width="15" color="#FA5E30" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.graduationReportObj.keep.num}}</div>
                            <div class="item-percent-text__desc">未结业</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="training-step5-flex-item flex-item-bg2">
                <div class="item-title">
                    <div class="item-title__text">报到情况</div>
                </div>
                <div class="item-percent"><span class="item-percent__num">{{rules.statusReportObj.finish.percent}}</span><span class="item-percent__symbol">%</span></div>
                <div class="item-tip">报到率</div>
                <div class="item-percent-flex item-percent-flex2">
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.statusReportObj.finish.percent" :stroke-width="15" color="#14A6AC" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.statusReportObj.finish.num}}</div>
                            <div class="item-percent-text__desc">已报到</div>
                        </div>
                    </div>
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.statusReportObj.keep.percent" :stroke-width="15" color="#FA5E30" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.statusReportObj.keep.num}}</div>
                            <div class="item-percent-text__desc">未报到</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="training-step5-flex-item flex-item-bg3">
                <div class="item-title">
                    <div class="item-title__text">活动情况</div>
                </div>
                <div class="item-percent"><span class="item-percent__num">{{rules.sumActivityNum}}</span></div>
                <div class="item-tip">总活动数量</div>
                <div class="item-percent-flex">
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.notAtPercent" :stroke-width="15" color="#FA5E30" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.notAt}}</div>
                            <div class="item-percent-text__desc">未开始</div>
                        </div>
                    </div>
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.ongoingPercent" :stroke-width="15" color="#14A6AC" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.ongoing}}</div>
                            <div class="item-percent-text__desc">进行中</div>
                        </div>
                    </div>
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.hasEndedPercent" :stroke-width="15" color="#CCCCCC" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.hasEnded}}</div>
                            <div class="item-percent-text__desc">已结束</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="training-step5-flex-item flex-item-bg4">
                <div class="item-title">
                    <div class="item-title__text">课程情况</div>
                </div>
                <div class="item-percent"><span class="item-percent__num">{{rules.courseSumActivityNum}}</span></div>
                <div class="item-tip">总课程数量</div>
                <div class="item-percent-flex">
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.courseNotAtPercent" :stroke-width="15" color="#359DE9" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.courseNotAt}}</div>
                            <div class="item-percent-text__desc">未开始</div>
                        </div>
                    </div>
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.courseOngoingPercent" :stroke-width="15" color="#14A6AC" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.courseOngoing}}</div>
                            <div class="item-percent-text__desc">进行中</div>
                        </div>
                    </div>
                    <div class="item-percent-pos">
                        <el-progress type="circle" :width="134" :percentage="rules.courseHasEndedPercent" :stroke-width="15" color="#CCCCCC" :show-text="false"></el-progress>
                        <div class="item-percent-text">
                            <div class="item-percent-text__num">{{rules.courseHasEnded}}</div>
                            <div class="item-percent-text__desc">已结束</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="training-step-btns" v-if="formData.status !== 7">
            <el-button type="primary" size="mini" @click="postProject">提交结项</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TrainingStep5',
    props: ['formData'],
    data() {
        return {
            rules: {
                graduationReportObj: {
                    keep: {name: '未结业',num: 0, percent: 0},
                    finish: {name: '已结业',num: 0, percent: 0}
                },
                statusReportObj: {
                    keep: {name: '未报到',num: 0, percent: 0},
                    finish: {name: '已报到',num: 0, percent: 0}
                },
                courseHasEnded: 0,
                courseNotAt: 0,
                courseOngoing: 0,
                courseSumActivityNum: 0,
                hasEnded: 0,
                notAt: 0,
                ongoing: 0,
                sumActivityNum: 0
            }
        }
    },
    mounted() {
        this.postProjectInfo()
    },
    methods: {
        postProject() {
            this.$api.user.train.postProject({id: this.$route.query.id}).then(res => {
                this.$emit('submitProject')
            })
        },
        postProjectInfo() {
            this.$api.user.train.postProjectInfo({id: this.$route.query.id}).then(res => {
                res.data.graduationReportObj = {keep:{}, finish: {}}
                res.data.statusReportObj = {keep:{}, finish: {}}
                for (let item of res.data.graduationReport) {
                    item.percent = item.percent ? item.percent*1 : 0
                    if (item.name === '未结业') {
                        res.data.graduationReportObj.keep = item
                    }
                    if (item.name === '已结业') {
                        res.data.graduationReportObj.finish = item
                    }
                }
                for (let item of res.data.statusReport) {
                    item.percent = item.percent ? item.percent*1 : 0
                    if (item.name === '未报到') {
                        res.data.statusReportObj.keep = item
                    }
                    if (item.name === '已报到') {
                        res.data.statusReportObj.finish = item
                    }
                }
                res.data.courseHasEndedPercent = (res.data.courseHasEnded/res.data.courseSumActivityNum).toFixed(2)*100
                res.data.courseNotAtPercent = (res.data.courseNotAt/res.data.courseSumActivityNum).toFixed(2)*100
                res.data.courseOngoingPercent = (res.data.courseOngoing/res.data.courseSumActivityNum).toFixed(2)*100
                res.data.hasEndedPercent = (res.data.hasEnded/res.data.sumActivityNum).toFixed(2)*100
                res.data.notAtPercent = (res.data.notAt/res.data.sumActivityNum).toFixed(2)*100
                res.data.ongoingPercent = (res.data.ongoing/res.data.sumActivityNum).toFixed(2)*100
                this.rules = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.training-step5 {
    background: $white_bg_color;
    .training-step5-flex {
        display: flex;
        flex-wrap: wrap;
        padding: .45rem 1.05rem .5rem;
    }
    .training-step5-flex-item {
        width: calc(50% - .15rem);
        border-radius: .04rem .04rem 0 0;
        margin-bottom: .3rem;
        &:nth-child(2n) {
            margin-left: .3rem;
        }
    }
    .item-title {
        font-size: .2rem;
        color: $font_color_D54;
        line-height: .17rem;
        &::before {
            content: "";
            display: inline-block;
            width: .03rem;
            height: .17rem;
            margin-right: .2rem;
            border-radius: .015rem;
        }
        .item-title__text {
            display: inline-block;
            width: calc(100% - .43rem);
            border-bottom: 1px solid $grey_border_color_eee;
            line-height: .54rem;
        }
    }
    .item-percent {
        margin-top: .25rem;
        text-align: center;
        line-height: .84rem;
        height: .84rem;
        .item-percent__num {
            font-size: .6rem;
            vertical-align: text-top;
        }
        .item-percent__symbol {
            font-size: .24rem;
            vertical-align: super;
        }
    }
    .item-tip {
        text-align: center;
        font-size: .16rem;
        color: $font_color;
    }
    .flex-item-bg1 {
        background: $bg_color_9FF;
        .item-title {
            &::before {
                background: $border_color_6F5;
            }
        }
        .item-percent {
            color: $border_color_6F5;
        }
    }

    .flex-item-bg2 {
        background: $bg_color_8FF;
        .item-title {
            &::before {
                background: $border_color_6AC;
            }
        }
        .item-percent {
            color: $border_color_6AC;
        }
    }

    .flex-item-bg3 {
        background: $bg_color_AF9;
        .item-title {
            &::before {
                background: $font_color_E30;
            }
        }
        .item-percent {
            color: $font_color_E30;
        }
    }

    .flex-item-bg4 {
        background: $bg_color_BFF;
        .item-title {
            &::before {
                background: $border_color_DE9;
            }
        }
        .item-percent {
            color: $border_color_DE9;
        }
    }

    .item-percent-flex {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: .4rem 0;
    }

    .item-percent-flex2 {
        padding: .4rem .5rem;
    }

    .item-percent-pos {
        position: relative;
        .item-percent-text {
            position: absolute;
            top: .4rem;
            left: 50%;
            margin-left: -0.21rem;
        }
        .item-percent-text__num {
            color: $font_color_7D;
            font-size: .36rem;
            text-align: center;
        }
        .item-percent-text__desc {
            color: $grey_font_color_80;
            font-size: .14rem;
        }
    }

    .training-step-btns {
        height: .83rem;
        padding: .24rem 0 .3rem;
        border-top: 1px solid $grey_border_color_e6;
        text-align: center;
        .el-button {
            vertical-align: top;
            width: .9rem;
        }
    }
}
</style>
<style lang="scss">
@import '../../../styles/variables.scss';

.training-step5 {
    
}
</style>
